import { MANAGE_INSURANCES_ACTION_TYPES } from '../actions/manage-insurances-actions';

const initialState = {
  pending: false,
  isInsuranceToDoTaskCompleting: false,
  uploadInsuranceCardModal: {
    isOpened: false,
    cardType: null,
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case MANAGE_INSURANCES_ACTION_TYPES.SET_INSURANCE_RELATED_DATA_FETCHING: {
      return {
        ...state,
        pending: payload,
      };
    }

    case MANAGE_INSURANCES_ACTION_TYPES.SET_UPLOAD_INSURANCE_CARD_MODAL_DATA: {
      return {
        ...state,
        uploadInsuranceCardModal: payload,
      };
    }

    case MANAGE_INSURANCES_ACTION_TYPES.SET_INSURANCE_TO_DO_TASK_COMPLETING: {
      return {
        ...state,
        isInsuranceToDoTaskCompleting: payload,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/reducers/common.js